export default __webpack_public_path__ + "static/feature-4-a452e89c63f6c08a89969fdcb5424d1f.png";